import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { PAGE_PROPS } from "../constants/common";
import { IUserItem } from "../../Components/users/types";
import { ISearchAPIPayload } from "../types/common";
import { SCHEDULE_FINE_INITIAL_STATE } from "../constants/scheduleFine.constants";

export const getAllPagedScheduleFines = createAsyncThunk(
  "scheduleFines/getAllPaged",
  async (data: ISearchAPIPayload) => {
    const response = await axios.post("/api/ScheduleOffence/GetPaged", data);
    return response.data;
  }
);

export const getAllScheduleFines = createAsyncThunk(
  "scheduleFines/getAll",
  async () => {
    const response = await axios.get("/api/ScheduleOffence/GetAll");
    return response.data;
  }
);

export const addScheduleFine = createAsyncThunk(
  "scheduleFines/add",
  async (data: Partial<IUserItem>) => {
    const response = await axios.post("/api/ScheduleOffence/Create", data);
    return response.data;
  }
);

export const updateScheduleFine = createAsyncThunk(
  "scheduleFines/update",
  async (data: Partial<IUserItem>) => {
    const response = await axios.post("/api/ScheduleOffence/Update", data);
    return response.data;
  }
);

export const deleteScheduleFine = createAsyncThunk(
  "scheduleFines/block",
  async (id: number) => {
    const response = await axios.post("/api/ScheduleOffence/Delete/" + id);
    return response.data;
  }
);

export const getCustomerFinesByFindId = createAsyncThunk(
  "scheduleFines/getCustomerFinesByFindId",
  async (customerId: number) => {
    const response = await axios.get(
      "/api/Fine/GetFinesByCustomerId/" + customerId
    );
    return response.data;
  }
);

export const scheduleFineSlice = createSlice({
  name: "scheduleFine",
  initialState: SCHEDULE_FINE_INITIAL_STATE,
  reducers: {
    onChangeSchduleFineScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    onChangeSchduleFineList: (state, action) => {
      state.pageProps = action.payload;
    },
    onSelectScheduleFine: (state, action) => {
      state.selectedScheduleFine = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPagedScheduleFines.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPagedScheduleFines.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.result ?? PAGE_PROPS;
        state.error = null;
      })
      .addCase(getAllPagedScheduleFines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getAllScheduleFines.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllScheduleFines.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.result ?? PAGE_PROPS;
        state.error = null;
      })
      .addCase(getAllScheduleFines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(addScheduleFine.pending, (state) => {
        state.loading = true;
      })
      .addCase(addScheduleFine.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addScheduleFine.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(updateScheduleFine.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateScheduleFine.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateScheduleFine.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(deleteScheduleFine.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteScheduleFine.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteScheduleFine.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getCustomerFinesByFindId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerFinesByFindId.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.customerFines = action.payload?.result || [];
      })
      .addCase(getCustomerFinesByFindId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const {
  onChangeSchduleFineScreen,
  onChangeSchduleFineList,
  onSelectScheduleFine,
} = scheduleFineSlice.actions;

export default scheduleFineSlice.reducer;
